/**
 * PeopleHR Credential Form
 *
 * Form for configuring PeopleHR API credentials with:
 * - API Key for authentication
 */

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface PeopleHRFormData {
  apiKey: string;
}

interface PeopleHRCredentialFormProps {
  formData: PeopleHRFormData;
  onChange: (data: Partial<PeopleHRFormData>) => void;
  isEditing?: boolean;
  testResult?: { success: boolean; message: string; data?: unknown; details?: unknown } | null;
  testing?: boolean;
  onTest?: () => Promise<void>;
}

export function PeopleHRCredentialForm({
  formData,
  onChange,
  isEditing = false,
}: PeopleHRCredentialFormProps) {
  const handleChange = (field: keyof PeopleHRFormData, value: string) => {
    onChange({ [field]: value });
  };

  return (
    <div className="space-y-4">
      {/* API Key */}
      <div className="space-y-2">
        <Label htmlFor="apiKey" className="text-sm font-medium">
          API Key <span className="text-red-500">*</span>
        </Label>
        <Input
          id="apiKey"
          type="password"
          placeholder={isEditing ? "Leave unchanged or enter new API key" : "Enter your PeopleHR API key"}
          value={formData.apiKey || ''}
          onChange={(e) => handleChange('apiKey', e.target.value)}
          autoComplete="new-password"
          className="font-mono text-sm"
        />
        <p className="text-xs text-muted-foreground">
          Your PeopleHR API key from Settings &gt; API
        </p>
      </div>
    </div>
  );
}

export default PeopleHRCredentialForm;
